import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import AutopayScheduleService from 'services/autopayScheduleService';

export const PaymentContext = React.createContext();

export function PaymentContextProvider({ children }) {
  const [amount, setAmount] = useState(0);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [securityDepositAmount, setSecurityDepositAmount] = useState(0);
  const [accountId, setAccountId] = useState(null);
  const [isFullPayment, setIsFullPayment] = useState(true);
  const [paymentOptions, setPaymentOptions] = useState({
    balance: true,
    securityDeposit: true,
  });
  const [autopaySchedule, setAutopaySchedule] = useState(null);
  const [checkFormValues, setCheckFormValues] = useState({});

  const [loadedAutopaySchedule] = AutopayScheduleService.useFindAll({});

  useEffect(() => {
    setAutopaySchedule(loadedAutopaySchedule?.[0]);
  }, [loadedAutopaySchedule]);

  const resetPaymentContext = useCallback(() => {
    setAmount(0);
    setBalanceAmount(0);
    setSecurityDepositAmount(0);
    setAccountId(null);
    setIsFullPayment(true);
    setPaymentOptions({
      balance: true,
      securityDeposit: true,
    });
    setCheckFormValues({});
  }, []);

  const value = {
    amount,
    setAmount,
    accountId,
    setAccountId,
    isFullPayment,
    setIsFullPayment,
    balanceAmount,
    setBalanceAmount,
    securityDepositAmount,
    setSecurityDepositAmount,
    paymentOptions,
    setPaymentOptions,
    autopaySchedule,
    setAutopaySchedule,
    checkFormValues,
    setCheckFormValues,
    resetPaymentContext,
  };

  return (
    <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>
  );
}

PaymentContextProvider.defaultProps = {
  children: null,
};
PaymentContextProvider.propTypes = {
  children: PropTypes.node,
};

export default { PaymentContextProvider, PaymentContext };
